import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { Badge, Descriptions, Input, Button, DatePicker, message, Tooltip } from "antd";
import axiosInstance from "../../utils/axiosInstance";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  CheckOutlined, EditOutlined, ArrowLeftOutlined
} from "@ant-design/icons";
function CompanyDetail() {
  const params = useParams();
  const [isLoading, setIsloading] = useState(false);
  const [islLoading, setIslloading] = useState(false);
  const [company, setCompany] = useState();
  const [editMode, setEditMode] = useState(false);
  const [success, setSuccess] = useState(false);
  const [editedCompany, setEditedCompany] = useState(
    company ? { ...company } : {}
  );
  const [expirationDate, setExpirationDate] = useState(null);
  const [accessUser, setAccessUser] = useState("");
  const [accessContract, setAccessContract] = useState("");
  const [editingAccessFields, setEditingAccessFields] = useState(false);


  const select = useSelector((state) => state.auth.userInfo);

  const user_role = select.role;
  const navigate = useNavigate();

  const handleSendAccessCode = async () => {
    if (!expirationDate || !accessUser || !accessContract) {
      return message.warning("Please fill all fields");
    }
    try {
      setIslloading(true);
      await axiosInstance.post("/company/send-access-code/", {
        company_id: company?.id,
        expiration_date: expirationDate,
        access_users: accessUser,
        access_contracts: accessContract
      });
      message.success("Access info updated!");
      setEditingAccessFields(false);
      fetchCompanys();
    } catch (error) {
      message.error(error?.response?.data?.error || "Failed to update access info");
    } finally {
      setIslloading(false);
    }
  };

  const handleCancel = () => {
    setEditMode(false);
    setEditedCompany({ ...company });
  };

  const handleSave = () => {
    axiosInstance.put(`/user/${params.pk}/update/`, editedCompany)
      .then((response) => {
        // Handle successful response
        setEditMode(false);
        setSuccess(true);
      })
      .catch((error) => {
        // Handle error
        console.error("Error updating user details:", error);
      });

    setEditMode(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCompany((prevCompany) => ({
      ...prevCompany,
      [name]: value,
    }));
  };

  if (islLoading) {
    message.loading("Code Sending To Admin", 0)
  }
  const fetchCompanys = async () => {
    try {
      const response = await axiosInstance.get(`/company/${params.pk}/get/`, editedCompany)
      setIsloading(false);
      setCompany(response.data);
      setEditedCompany(response.data);
      // window.location.reload(); // Update the state with the fetched company data
    } catch (error) { }
  };

  useEffect(() => {
    setIsloading(true);
    fetchCompanys();
  }, [editMode]);

  useEffect(() => {
    localStorage.setItem("gyrwmnqijpkl", "xvzndrpkloqo9");
  });

  return (
    <>
      {company ? (
        <>
          <div className="py-3 flex user-heading ">
            <div onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
      <ArrowLeftOutlined style={{ fontSize: "20px" }} />
    </div>
            <h1 className="font-bold text-[22px]">Company Info</h1>
            <div className="flex user-info-heading">
              {!editMode && (
                <>
                  {(user_role && user_role.toLowerCase() === "admin") ||
                    user_role.toLowerCase() === "superadmin" ? (
                    <span>
                    </span>
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
          <Descriptions size="small" className="text-[12px] [&_.ant-descriptions-item-label]:text-[11px] [&_.ant-descriptions-item-content]:text-[12px] [&_.ant-descriptions-item]:p-[6px]" title="" layout="vertical" bordered column={3}>
            <Descriptions.Item label="Company Name" span={3}>
              {editMode && editedCompany ? (
                <Input name="name" value={editedCompany.name} onChange={handleInputChange} />
              ) : (
                company.name
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Active Status">
              {!company.is_active ? (
                <Badge color="red" status="" text="Inactive" />
              ) : (
                <Badge status="success" text="Running" />
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Admin's Name">
              {editMode && editedCompany ? (
                <Input name="name_of_admin" value={editedCompany.name_of_admin} onChange={handleInputChange} />
              ) : (
                company.name_of_admin
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Admin's Contact">
              {editMode && editedCompany ? (
                <Input name="admin_contact_number" value={editedCompany.admin_contact_number} onChange={handleInputChange} />
              ) : (
                company.admin_contact_number
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Admin's Email">
              {editMode && editedCompany ? (
                <Input name="admin_email" value={editedCompany.admin_email} onChange={handleInputChange} />
              ) : (
                company.admin_email
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Company License No.">
              {editMode && editedCompany ? (
                <Input name="cin" value={editedCompany.cin} onChange={handleInputChange} />
              ) : (
                company.cin
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Contact">
              {editMode && editedCompany ? (
                <Input name="contact" value={editedCompany.contact} onChange={handleInputChange} />
              ) : (
                company.contact
              )}
            </Descriptions.Item>

            <Descriptions.Item label="TAX License No.">
              {editMode && editedCompany ? (
                <Input name="gst_number" value={editedCompany.gst_number} onChange={handleInputChange} />
              ) : (
                company.gst_number
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Domain">
              {editMode && editedCompany ? (
                <Input name="domain" value={editedCompany.domain} onChange={handleInputChange} />
              ) : (
                company.domain
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Number of Licence">
              {editMode && editedCompany ? (
                <Input name="number_of_licence" value={editedCompany.number_of_licence} onChange={handleInputChange} />
              ) : (
                company.number_of_licence
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Total Users">
              {editMode && editedCompany ? (
                <Input name="user_count" value={editedCompany.user_count} onChange={handleInputChange} />
              ) : (
                company.user_count
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Company Created on">
              {new Date(company.valid_from).toLocaleDateString()}
            </Descriptions.Item>
            <Descriptions.Item label="Valid From">
              {new Date(company.valid_from).toLocaleDateString()}
            </Descriptions.Item>
            <Descriptions.Item label="Valid To">
              <div className="flex items-center justify-between gap-2">
                {editingAccessFields ? (
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(current) => current && current < dayjs().startOf("day")}
                    defaultValue={expirationDate ? dayjs(expirationDate) : null}
                    onChange={(date, dateString) => setExpirationDate(dateString)}
                  />
                ) : (
                  new Date(company.expiration_date).toLocaleDateString()
                )}
              </div>
            </Descriptions.Item>

            <Descriptions.Item label="Access User Limit">
              {editingAccessFields ? (
                <Input
                  value={accessUser}
                  onChange={(e) => setAccessUser(e.target.value)}
                  placeholder="Enter user limit"
                />
              ) : (
                company.access_user_limit || "-"
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Access Contract Limit">
              {editingAccessFields ? (
                <Input
                  value={accessContract}
                  onChange={(e) => setAccessContract(e.target.value)}
                  placeholder="Enter contract limit"
                />
              ) : (
                company.access_contract_limit || "-"
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Send Access Code " span={3}>
              {editingAccessFields ? (
                <div className="flex gap-4">
                  <Button
                    type="primary"
                    onClick={handleSendAccessCode}
                    loading={islLoading}
                  >
                    Save All
                  </Button>
                  <Button onClick={() => {
                    setEditingAccessFields(false);
                    setAccessUser(company.access_user_limit || "");
                    setAccessContract(company.access_contract_limit || "");
                    setExpirationDate(company.expiration_date || null);
                  }}>
                    Cancel
                  </Button>
                </div>
              ) : (
                <Button
                  icon={<EditOutlined />}
                  onClick={() => setEditingAccessFields(true)}
                >
                  Edit
                </Button>
              )}
            </Descriptions.Item>


          </Descriptions>
          {editMode && editedCompany && (
            <div className="mt-12 flex">
              <Button onClick={handleCancel} className="">
                Cancel
              </Button>
              <Button type="primary" onClick={handleSave} className="ml-12">
                Save
              </Button>
            </div>
          )}
        </>
      ) : (
        ""
      )}
    </>
  );
}

export default CompanyDetail;
